// extracted by mini-css-extract-plugin
export default {"draggable":"styles-module__draggable__src-labstep-web-components-Entity-Draggable-_GgbG9"};